import Tooltip from 'tooltip.js';

const tooltipContainer = document.querySelector('.ui-tooltips');

// Long enough to cross the gap onto the tooltip without it closing (WCAG 1.4.13)
const HIDE_DELAY = 150;

// Only one tooltip shows at a time
let active = null;

function show(entry, delay) {
  clearTimeout(entry.timer);
  entry.timer = setTimeout(() => {
    if (active && active !== entry) hide(active, 0);
    entry.tip.show();
    active = entry;
  }, delay);
}

// A zero delay hides synchronously, so `active` is already cleared for the next
// keypress (two Escapes in one tick would otherwise both be swallowed)
function hide(entry, delay) {
  clearTimeout(entry.timer);
  if (delay) {
    entry.timer = setTimeout(() => hide(entry, 0), delay);
    return;
  }
  entry.tip.hide();
  if (active === entry) active = null;
}

export function initTooltips() {
  // Callers run this after re-rendering a panel. A tooltip whose trigger went
  // with the old markup never gets its mouseleave, so drop it here.
  if (active && !active.item.isConnected) hide(active, 0);

  const stuffToTip = document.querySelectorAll('.js-ui-tooltip');
  stuffToTip.forEach(item => {
    const entry = {
      tip: new Tooltip(item, {
        trigger: 'manual',
        container: tooltipContainer,
        title: item.getAttribute('data-tooltip'),
        placement: 'bottom',
        offset: '0, 4px',
        html: false,
        boundariesElement: document.body
      }),
      item,
      timer: null
    };
    const showDelay = Number(item.getAttribute('data-tooltip-delay')) || 750;

    item.addEventListener('mouseenter', () => show(entry, showDelay));
    item.addEventListener('mouseleave', () => hide(entry, HIDE_DELAY));
    // focusin/focusout so a wrapper shows its tip when the link inside it is focused
    item.addEventListener('focusin', () => show(entry, 0));
    item.addEventListener('focusout', evt => {
      if (!item.contains(evt.relatedTarget)) hide(entry, 0);
    });
    item.removeAttribute('data-tooltip');
    item.classList.remove('js-ui-tooltip');
  });
}

// Keep the tooltip open while the pointer is over it
if (tooltipContainer) {
  tooltipContainer.addEventListener('mouseover', () => {
    if (active) clearTimeout(active.timer);
  });
  tooltipContainer.addEventListener('mouseout', evt => {
    if (active && !tooltipContainer.contains(evt.relatedTarget)) hide(active, HIDE_DELAY);
  });
}

// Escape dismisses an open tooltip. Capture and stop it there so the same press
// doesn't also close the tray or menu the tooltip belongs to. A tooltip whose
// trigger was replaced (e.g. re-rendered search results) is orphaned and never
// got its mouseleave, so hide it but let the press through to close the panel.
window.addEventListener('keydown', evt => {
  if (evt.key !== 'Escape' || !active) return;
  if (active.item.isConnected) evt.stopPropagation();
  hide(active, 0);
}, true);

// Make initTooltips available globally
if (!window.ui) window.ui = {};
window.ui.initTooltips = initTooltips;

// Optionally auto-initialize on import
initTooltips();
